import { theme } from "config/theme";

export default function isProdigioProject() {
    const prodigioBrands = ["proenem", "promilitares"];

    return prodigioBrands.some((brand) => brand === theme.project.slug);
}
